module.exports = __webpack_public_path__ + "static/media/time.85bb7206.svg";